import * as React from 'react';
import './styles.scss';
import { ErrorMessage } from 'react-hook-form';


export const ErrorPanel: React.FunctionComponent = ({ children }) => {
  return (

    <div className="error-panel__container">
      <div className="error-panel__icon-container"><div className="icon--error-white"></div></div>
      <div className="error-panel__message">
        <div className="error-panel__message-container">
          {children}
        </div>
      </div>
    </div>

  )
};